import React, { useEffect, useState } from 'react'
const LocationCountBlurb = ({ locationInfo, formTouched }) => {
  const [blurb, setBlurb] = useState('')
  const changeTheBlurb = () => {
    if (formTouched === true) {
      if (locationInfo.length > 0) {
        setBlurb(``)
      } else {
        setBlurb(
          `Hmmm... We couldn't find any stores near you. Trying looking at a wider area.`,
        )
      }
    } else {
      if (locationInfo.length > 0) {
        setBlurb(``) //if we start dragging before entering a zip
      } else {
        setBlurb(`Please enter your zip code to see stores near you.`)
      }
    }
  }

  useEffect(() => {
    changeTheBlurb()
  }, [locationInfo])

  return <>{blurb && <div className="locator--blurb-container">{blurb}</div>}</>
}
export default LocationCountBlurb
